export const apiUrl="https://nanosoft.technology/academy_new/api"